import firebase from 'firebase'
import firestore from 'firebase/firestore'

// Initialize Firebase
  var config = {
    apiKey: "AIzaSyB741ETjCpFK9QtgMxHmfPpLG4HA-uKZug",
    authDomain: "mumbl-636b4.firebaseapp.com",
    databaseURL: "https://mumbl-636b4.firebaseio.com",
    projectId: "mumbl-636b4",
    storageBucket: "mumbl-636b4.appspot.com",
    messagingSenderId: "1079049865333"
  };
  const firebaseApp = firebase.initializeApp(config);
  // bugfix error in console
  firebaseApp.firestore().settings({ timestampsInSnapshots: true })

  // export firestore database
  export default firebaseApp.firestore()



// WEBPACK FOOTER //
// ./src/firebase/init.js